// extracted by mini-css-extract-plugin
module.exports = {"tab_content":"crowdfunding_tab_layout__tab_content___HrhVX"};